/*
 * @Author: wangyan1
 * @Description:
 * @Date:  2022-04-22 15:19:00
 * @LastEditTime: 2023-12-25 10:59:22
 * @FilePath: /teacher-xkh-web/src/service/groupManage/index.js
 */
import http from '../http'
import url from './index-url'
const { post } = http

export default {
  // 金币-查询机构下学生总积分列表
  getCoinList(data) {
    return post(url.getCoinList, data)
  },
  // 查询某个学生扣减明细
  getCoinById(data) {
    return post(url.getCoinById, data)
  },
  // 金币-扣减
  deductionCoins(data) {
    return post(url.deductionCoins, data)
  },
  // 金币-查询机构下所有学生扣减明细
  getAllCoinsPage(data) {
    return post(url.getAllCoinsPage, data)
  },
  // 金币-增加
  addCoins(data) {
    return post(url.addCoins, data)
  }
}